export enum IconSize {
    XXL = 72,
    XL = 42,
    L = 28,
    M = 18,
    S = 14
}